import { observer } from "mobx-react";
import Text from "../../../Styled/Text";
import { applyTranslationIfExists } from "../../../Language/languageHelpers";
import MinMaxLevelMixin from "../../../ModelMixins/MinMaxLevelMixin";
import { Spacing } from "../../../Styled/Spacing";
import { useTranslation } from "react-i18next";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ScaleWorkbenchInfo = observer(_ref => {
  let {
    item
  } = _ref;
  const {
    i18n
  } = useTranslation();
  if (!MinMaxLevelMixin.isMixedInto(item) || !item.scaleWorkbenchInfo) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    }), /*#__PURE__*/_jsx(Text, {
      children: applyTranslationIfExists(item.scaleWorkbenchInfo, i18n)
    })]
  });
});